module.exports = __webpack_public_path__ + "static/media/parul.49be5cee.webp";